export class ConsoleHelper {
	logToConsole(data: {
		type: 'Warning' | 'Error' | 'Info';
		message: string;
		partA?: string;
		partB?: string;
		data?: any;
	}): void {
		const message = `[${data.type}]${data.partA ? `[${data.partA}]` : ''}${data.partB ? `[${data.partB}]` : ''}: ${
			data.message
		}`;

		if (data.type === 'Warning') {
			if (data.data) {
				console.warn(message, data.data);
			} else {
				console.warn(message);
			}
		} else if (data.type === 'Error') {
			if (data.data) {
				console.error(message, data.data);
			} else {
				console.error(message);
			}
		} else {
			if (data.data) {
				console.log(message, data.data);
			} else {
				console.log(message);
			}
		}
	}
}

export const consoleHelper = new ConsoleHelper();
